import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'oc-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent implements OnInit {
  @Input() name; 
  @Input() settings = false;

  constructor() { }

  ngOnInit() {
  }

}
